import { DuplicatePostDocument } from '@/graphql/generated/duplicate-post.generated';
import { useMutation } from '@apollo/client';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { usePosts } from '../../providers/PostsProvider';
import { usePostNavigation } from '@/hooks/use-post-navigation';

const PostDuplicateDialog = ({
    postId,
    children,
    open,
    onCancel,
}: {
    postId: string | null;
    children: React.ReactNode;
    open: boolean;
    onCancel: () => void;
}) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { navigateToPost } = usePostNavigation();
    const { addPost } = usePosts();

    const [duplicatePost, { loading: duplicating }] = useMutation(DuplicatePostDocument, {
        onCompleted: ({ duplicatePost }) => {
            enqueueSnackbar(t('snackbar.content.duplicated'));
            navigateToPost({ postId: duplicatePost.id, ignorePostOpenCheck: true });
            addPost(duplicatePost);
            onCancel();
        },
        onError: (e) => {
            enqueueSnackbar(e.message);
        },
    });

    if (!postId) {
        return null;
    }

    return (
        <>
            {children}
            <Dialog open={open} keepMounted>
                <DialogTitle>{t('content.duplicate.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('content.duplicate.support-text')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} disabled={duplicating}>
                        {t('str.action.escape.cancel')}
                    </Button>
                    <Button onClick={() => duplicatePost({ variables: { postId } })} loading={duplicating}>
                        {t('str.action.duplicate')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default PostDuplicateDialog;
